import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  EstablecerPinUsuario
} from "@fixeduy/restaurantestypes";

const establecerPinUsuario = async (
  data: EstablecerPinUsuario
): Promise<CloudFunctionResponse> => {
  const payload = { func: "establecerPinUsuario" as const, params: data };

  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run(payload);
  const out = result.data as CloudFunctionResponse;

  return out;
};

export { establecerPinUsuario };
